'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";
//import { jsPDF } from "jspdf";
//import {fontOpenSans} from "../lib/font_opensans.js";

EwSiteApp.controller('LayoutCtrl', ["$scope", "$mdSidenav", "jsDataService", function($scope, $mdSidenav, jsDataService){
	$scope.rightNavTabs = {
		selectedIndex: 0
	};
	$scope.openMenu = function(){
		$mdSidenav('left').open();
	};
	$scope.openRight = function(){
		$scope.rightNavTabs.selectedIndex = 0;
		if(arguments[0] && !isNaN(arguments[0]) && arguments[0] > 0){
			$scope.rightNavTabs.selectedIndex = parseInt(arguments[0]);
		}
		$mdSidenav('right').open();
	};
	$scope.toggleSidenav = buildToggler('left');
	$scope.toggleRightNav = buildToggler('right');
	function buildToggler(componentId) {
	  return function() {
	    $mdSidenav(componentId).toggle();
	  };
	}
	
	$scope.timeCfg = function(){
		return jsDataService.get('cfgTime', {});
	};

	$scope.home = function (){
		localStorage.removeItem('StatisticsListCtrlQuery');
		localStorage.removeItem('ReportsListCtrlQuery');
		location.href = jsDataService.get('home_url', '');
	};
}]);


class expandCtrl
{
	constructor(){
		this.opened = false;
	}
	
	isOpen(){
		return this.opened;
	}
	
	toggle(){
		this.opened = !this.opened;
	}
	
	open(){
		this.opened = true;
	}
	
	close(){
		this.opened = false;
	}
	
	openFrame(onOpen, onClose){
		return (this.opened) ? onOpen : onClose;
	}
}

EwSiteApp.controller('expandCtrl', expandCtrl);

EwSiteApp.controller('MessagePreview', ["$scope", "$mdDialog", "$http", "$filter", "jsDataService", "notify", "id", function($scope, $mdDialog, $http, $filter, jsDataService, notify, id){
	$scope.loading = true;
	$scope.noUrl = false;
	$scope.found = false;
	$scope.msg = {};
	const url = jsDataService.get('messagePreviewUrl');
	
	if(url){
		
		$http({
			url: url,
			method: 'GET',
			responseType: 'json',
			params: {
				id: id
			}
		}).then(function(response){
			$scope.loading = false;
			if(response.data){
				if(response.data.success && typeof(response.data.item) !== 'undefined'){

					$scope.msg = response.data.item;
					$scope.found = true;
				}
				if(response.data.message){
					notify(response.data.message, !response.data.success);
				}
			}
			else{
				notify('Communication Error', true);
			}
		}, function(response){
			console.log("HTTP ERROR");
			console.log(response);
			notify('Network error, Status: ' + response.status, true);
			$scope.loading = false;
		});
	}
	else{
		$scope.noUrl = true;
	}
	
	$scope.close = function() {
		$mdDialog.cancel();
	};

}]);

EwSiteApp.controller('ImagePreviewCtrl', ["$scope", "$mdDialog", "image", function($scope, $mdDialog, image){
	$scope.image = image;
	$scope.close = function() {
		$mdDialog.cancel();
	};
}]);

EwSiteApp.controller('StoreditemsFindCtrl', ["$scope", "$mdDialog", "$http", "jsDataService", "notify", "filters", function($scope, $mdDialog, $http, jsDataService, notify, filters){
	
	const findUrl = jsDataService.get('cfgItemsFindUrl');
	
	$scope.promise;
	$scope.data = [];
	$scope.tbOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};
	$scope.tbLimitOptions = [5, 10, 20, 50, 100];
	$scope.tbQuery = {
		limit: 10,
		page: 1,
		filters: filters
	};
	$scope.total = 0;
	
	$scope.loadData = function(){
		if(findUrl){
			$scope.promise = $http({
				url: findUrl,
				method: 'GET',
				params: $scope.tbQuery
			}).then(function(response){
				if(response.data.success){
					$scope.data = getFormatedData(response.data.data);
					$scope.total = response.data.total;
				}
				if(response.data.message){
					notify(response.data.message, !response.data.success);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
			});
		}
	};
	
	$scope.loadData();
	
	$scope.$watch(function(){
		return angular.toJson($scope.tbQuery);
	},function(){
		$scope.loadData();
	});
	
	function getFormatedData(data){
		for(let itm of data){
			if(typeof(itm.location) !== 'undefined' && !(itm.location instanceof locationModel)){
				itm.location = new locationModel(itm.location);
			}
			else{
				itm.location = new locationModel({});
			}
			
		}
		return data;
	}
	
	$scope.getItem = function(e, row){
		$mdDialog.hide(row);
	};
	
	$scope.close = function() {
		$mdDialog.cancel();
	};

}]);
